var render = function render(){var _vm=this,_c=_vm._self._c;return _c('savvy',{attrs:{"id":"flow_90iaf85f71dh8fe5j531jf3a8"}})
}
var staticRenderFns = []

export { render, staticRenderFns }